<template>
	<ul class="menu">
		<li class="all" v-if="isShowAll" :class="[isAll&&isShowAll&&!curNameId?'active':'']" @click="toAll">
			<a href="javascript:;">全部</a>
		</li>
		<li  v-for="(item,index) in menuList" :key="item.id">
			<div @click="isHideMenu(item)" class="parent-item" v-if="item.list&&item.list.length>0">
				<a href="javascript:;">{{item.categoryName}}</a>
				<i class="el-icon-arrow-down" :class="[item.isShowChild?'':'transform']"></i>
			</div>
			<div :class="[!isAll&&(item.id==curNameId)?'active':'']" @click="toDetail(item)" class="child-item" v-else>
				<a href="javascript:;">{{item.categoryName}}</a>
			</div>
			<AsideVideo :current="curNameId" :isShowAll="false" v-on="$listeners" v-if="item.list&&item.list.length>0&&!item.isShowChild" :menuList="item.list"></AsideVideo>
		</li>
	</ul>
</template>

<script>
	export default {
		name: 'AsideVideo',
		props: {
			menuList: {
				type: Array,
				default: []
			},
			isShowAll: {
				type:Boolean,
				default:false
			},
			isAll: {
				type:Boolean,
				default:true
			},
			current: {
				type: Number
			}
		},
		data(){
			return {
				curNameId: 0
			}
		},
		watch: {
			//监听当前点击节点的id
			current: {
				handler(num) {
					this.curNameId = num
				},
				deep: true,
				immediate: true
			}
		},
		methods: {
			isHideMenu(item){
				console.log(item)
				item.isShowChild = !item.isShowChild
				console.log(item.isShowChild)
				console.log('-----')
				this.$emit('toList', {
					id: item.id,
					parentId: item.parentId
				})
			},
			toAll(){
				//this.isAll = true
				this.curNameId == 0
				this.$emit('toList', {
					isAll: true
				})
			},
			toDetail(item){
				//this.isAll = false
				//this.currentId = item.id
				this.$emit('toList', {
					id: item.id,
					parentId: item.parentId,
					isAll: false
				})
			}
		}
	}
</script>

<style scoped lang="less">
	.menu{
		li{
			min-height: 44px !important;
			line-height: 44px;
			//padding: 0 0 0 14px;
			
			a{
				color: rgba(0, 0, 0, .5)
			}
			cursor: pointer;
			.parent-item {
				display: flex;
				justify-content: space-between;
				align-items: center;
				padding-left: 14px;
				a{
					flex: 1;
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;
				}
			}
			
			.parent-item:hover{
				color: #DE0515;
				a{
					color: #DE0515;
				}
			}
			.child-item{
				padding-left: 14px
			}
		}
		li.all {
			padding-left: 14px
		}
		.child-item.active, li.active{
			background: rgba(222, 5, 21,.1);
			border-right: 4px solid #DE0515;
			color: #000
		}
		.menu{
			.child-item{
				padding-left: 28px
			}
		}
		.transform{
			transform: rotate(180deg) scale(.8);
		}
		.el-icon-arrow-down{
			padding: 0 10px;
			transition: all .4s;
		}
	}
</style>
